/* eslint-disable no-nested-ternary */
import { useState } from "react";
import { ANY, HEIGHT_RANGE } from "helpers/constants";

export const compute = {
	urlToApiParam: (value) => {
		if (value === ANY || !value) return null;
		return Number(value);
	},
	valueToUrl: (value) => {
		if (!value) return ANY;
		return value;
	},
};

export const isValid = (value) => {
	if (value === "") {
		return true;
	}

	const valueAsNumber = Number(value);

	return (
		Number.isInteger(valueAsNumber) &&
		valueAsNumber >= HEIGHT_RANGE.MIN &&
		valueAsNumber <= HEIGHT_RANGE.MAX
	);
};

const useFilterHeight = ({ initial }) => {
	const [value, setValue] = useState({
		from:
			initial?.from === ANY
				? null
				: initial?.from
				? Number(initial?.from)
				: null,
		to:
			initial?.to === ANY
				? null
				: initial?.to
				? Number(initial?.to)
				: null,
	});

	const range = {
		min: HEIGHT_RANGE.MIN,
		max: HEIGHT_RANGE.MAX,
	};

	const setValueHandler = (newValue) => {
		if (newValue === null) {
			setValue({ from: null, to: null });
		} else {
			setValue(newValue);
		}
	};

	return {
		range,
		compute,
		value,
		setValue: setValueHandler,
		selected: value,
		setSelected: setValueHandler,
		isSelected:
			(value.from !== null && value.from !== HEIGHT_RANGE.MIN) ||
			(value.to !== null && value.to !== HEIGHT_RANGE.MAX),
		isValid,
	};
};

export default useFilterHeight;
